export default "__VITE_ASSET__CM3wJt9N__"